
// This is the style entry file
import "../styles/index.css";
import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.start();

